import { Content } from 'src/styles/layout';
import styled from 'styled-components';

export const ButtonContainer = styled(Content)`
  text-align: right;
  padding-right: 20px;
  margin-bottom: 20px;
`;
